import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class SenfMelkModel extends BaseModel {
  RouteName = "SenfMelk";
  protected AuthState: boolean = true;
  public async GetSearch(ShomareParvande = "", CodeMelki = "", Name = "", LastName = "", FatherName = "", ShomareShenasname = "", SenfId = "") {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(
          `${this.RouteName}/search?ShomareParvande=${ShomareParvande}&CodeMelki=${CodeMelki}&Name=${Name}&LastName=${LastName}&FatherName=${FatherName}&ShomareShenasname=${ShomareShenasname}&SenfId=${SenfId}`
        );
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
  public async EditData(data: any) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).put(`${this.RouteName}?id=${data.id}`, data);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
  public async ChangeStatus(id: number) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}/Status/${id}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
}
